<template>
    <div class="doc-toolbar">
        <b-button-group size="sm" class="mr-1">
            <b-button variant="outline-secondary" title="굵게" @mousedown.prevent @click="cmd('bold')">
                <b>B</b>
            </b-button>
            <b-button variant="outline-secondary" title="기울임" @mousedown.prevent @click="cmd('italic')">
                <i>I</i>
            </b-button>
            <b-button variant="outline-secondary" title="밑줄" @mousedown.prevent @click="cmd('underline')">
                <u>U</u>
            </b-button>
        </b-button-group>

        <b-button-group size="sm" class="mr-1">
            <label class="doc-toolbar__color mb-0" title="글자 색" @mousedown.prevent>
                <span class="doc-toolbar__color-swatch">A</span>
                <input type="color" class="doc-toolbar__color-input" @input="cmd('foreColor', $event.target.value)">
            </label>
        </b-button-group>

        <b-button-group size="sm" class="mr-1">
            <b-button variant="outline-secondary" title="링크" @mousedown.prevent @click="onLink">
                링크
            </b-button>
            <b-button variant="outline-secondary" title="이미지" @mousedown.prevent @click="onImage">
                이미지
            </b-button>
        </b-button-group>

        <b-button-group size="sm">
            <b-button variant="outline-secondary" title="서식 지우기" @mousedown.prevent @click="cmd('removeFormat')">
                서식 지우기
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
// 본문 서식 툴바. 버튼 mousedown 에서 preventDefault 해 iframe 편집 selection 을 잃지
// 않고, click 시 부모(MailDocCanvas)로 command 를 올린다. 실제 execCommand 는 부모가
// iframe 문서에 실행한다.
export default {
    name: 'DocToolbar',
    methods: {
        cmd(command, value) {
            this.$emit('command', { command, value: value == null ? null : value })
        },
        onLink() {
            const url = window.prompt('링크 주소(URL)를 입력하세요', 'https://')
            if (url) this.cmd('createLink', url)
        },
        onImage() {
            const url = window.prompt('이미지 주소(URL)를 입력하세요', 'https://')
            if (url) this.cmd('insertImage', url)
        },
    },
}
</script>

<style scoped>
.doc-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 6px 8px;
    border: 1px solid #dee2e6;
    border-bottom: 0;
    border-radius: 4px 4px 0 0;
    background: #f8f9fa;
}
.doc-toolbar__color {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 31px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
}
.doc-toolbar__color-swatch {
    font-weight: bold;
    border-bottom: 3px solid #3d5afe;
    line-height: 1;
}
.doc-toolbar__color-input {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
}
</style>
